import React from 'react';
import { useDispatch } from 'react-redux';
import { deleteBetSlipBetLine } from '../../../../../store/actions/betSlip';
import styles from './DeleteButton.module.scss';

const DeleteButton = ({ bet }) => {
    const dispatch = useDispatch();

    const onDeleteClick = () => {
        dispatch(
            deleteBetSlipBetLine({
                eventId: bet.eventId,
                marketId: bet.marketId,
                outcomeId: bet.outcomeId,
            })
        );
    };

    return <button className={`icon-close-thin ${styles.deleteBtn}`} onClick={onDeleteClick} />;
};

export default DeleteButton;
